// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopOver_overlay__Fmw8X {
  z-index: 100;
  max-width: 200px;
  min-width: 150px;
  border-radius: 5px;
  border: 1px solid #bbb;
  background: var(--white-color);
  box-shadow: 0px 15px 30px 0px rgba(58, 153, 74, 0.18);
  transition: all 0.3s ease-in-out;
}

.PopOver_overlay__Fmw8X .PopOver_overlayLink__XznHC {
  text-decoration: none;
  text-transform: capitalize;
  cursor: pointer;
  padding: 10px;
}

.PopOver_overlayLink__XznHC:hover {
  background: var(--primary-color);
  color: var(--white-color);
}

.PopOver_overlayPopover__Bj2IY .popover-arrow {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/PopOver/PopOver.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".overlay {\n  z-index: 100;\n  max-width: 200px;\n  min-width: 150px;\n  border-radius: 5px;\n  border: 1px solid #bbb;\n  background: var(--white-color);\n  box-shadow: 0px 15px 30px 0px rgba(58, 153, 74, 0.18);\n  transition: all 0.3s ease-in-out;\n}\n\n.overlay .overlayLink {\n  text-decoration: none;\n  text-transform: capitalize;\n  cursor: pointer;\n  padding: 10px;\n}\n\n.overlayLink:hover {\n  background: var(--primary-color);\n  color: var(--white-color);\n}\n\n.overlayPopover :global(.popover-arrow) {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `PopOver_overlay__Fmw8X`,
	"overlayLink": `PopOver_overlayLink__XznHC`,
	"overlayPopover": `PopOver_overlayPopover__Bj2IY`
};
export default ___CSS_LOADER_EXPORT___;
